'use client';
import React from 'react';
// force fresh build
import Navbar from '@/components/Navbar';
import HeroSlider from '@/components/HeroSlider';
import AboutSection from '@/components/AboutSection';
import OurStorySection from '@/components/OurStorySection';
import QuoteBanner from '@/components/QuoteBanner';
import WhyChooseSection from '@/components/WhyChooseSection';
import ProjectsSection from '@/components/ProjectsSection';
import TestimonialsSection from '@/components/TestimonialsSection';
import BlogSection from '@/components/BlogSection';
import ContactSection from '@/components/ContactSection';
import SubscribeSection from '@/components/SubscribeSection';
import Footer from '@/components/Footer';

export default function HomePage() {
  return (
    <main className="font-avenir">
      {/* Sticky Navigation */}
      <Navbar />

      {/* 1. Hero Slider */}
      <HeroSlider />

      {/* 2. About / Intro Section */}
      <AboutSection />

      {/* 3. Our Story - Alternating Image/Text */}
      <OurStorySection />

      {/* 4. Quote Banner 1 */}
      <QuoteBanner
        quote="We are a collaborative conglomerate of seasoned financial experts, engineers, High Networth Investors (HNIs), and experienced real estate professionals, united by a shared vision of delivering innovative, reliable, and value-driven solutions."
        bgImage="https://images.unsplash.com/photo-1500382017468-9049fed747ef?w=1600&q=80"
        overlay="bg-brand-green/80"
      />

      {/* 5. Why Choose Us */}
      <WhyChooseSection />

      {/* 6. Quote Banner 2 */}
      <QuoteBanner
        quote="Upscaling Wealth. Transforming New Horizons. — Neo Capital Group redefines real estate investment through premium plot development, strategic land acquisition, and value-driven solutions for the modern investor."
        variant="mint"
      />

      {/* 7. Our Projects */}
      <ProjectsSection />

      {/* 8. Testimonials */}
      <TestimonialsSection />

      {/* 9. Blog Section */}
      <BlogSection />

      {/* 10. Contact Inquiry */}
      <ContactSection />

      {/* 11. Subscribe Section */}
      <SubscribeSection />

      {/* 12. Footer */}
      <Footer />
    </main>
  );
}
